import type { ApiOk, ApiResp } from '@znjj/shared';

/** 应用基路径（Vite 的 BASE_URL 去掉尾部斜杠）：子路径部署为 '/znjj'，根路径部署为 '' */
export const APP_BASE = import.meta.env.BASE_URL.replace(/\/$/, '');

/** REST API 基地址，随应用基路径变化 */
export const API_BASE = `${APP_BASE}/api`;

/** 统一请求：解析 { code, msg, data } 包络，code!==0 抛错 */
export async function apiGet<T>(path: string): Promise<T> {
  const res = await fetch(APP_BASE + path, { headers: authHeader() });
  return unwrap<T>(res);
}

export async function apiJson<T>(
  method: 'POST' | 'PATCH' | 'PUT' | 'DELETE',
  path: string,
  body?: unknown,
): Promise<T> {
  // 无 body 时不带 content-type：Fastify 会拒绝「content-type=json 但 body 为空」的请求
  const headers: Record<string, string> = { ...authHeader() };
  if (body !== undefined) headers['content-type'] = 'application/json';
  const res = await fetch(APP_BASE + path, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  return unwrap<T>(res);
}

function authHeader(): Record<string, string> {
  const token = localStorage.getItem('znjj_token');
  return token ? { authorization: `Bearer ${token}` } : {};
}

async function unwrap<T>(res: Response): Promise<T> {
  const text = await res.text();
  let json: ApiResp<T>;
  try {
    json = JSON.parse(text) as ApiResp<T>;
  } catch {
    throw new Error(`响应不是 JSON (HTTP ${res.status}): ${text.slice(0, 120)}`);
  }
  if (json.code !== 0) throw new Error(json.msg || `请求失败 (${json.code})`);
  return (json as ApiOk<T>).data;
}
